// Period presets for dashboard chart filters. getDateRangeByPeriod(period)
// returns { start, end } as YYYY-MM-DD strings to pass to the dashboard
// controllers. Default period is "today" so charts load today's data.

import moment from "moment";

const FMT = "YYYY-MM-DD";

export const CHART_PERIOD_OPTIONS = [
  { value: "today", label: "Today" },
  { value: "yesterday", label: "Yesterday" },
  { value: "last7", label: "Last 7 Days" },
  { value: "last30", label: "Last 30 Days" },
  { value: "thisMonth", label: "This Month" },
  { value: "lastMonth", label: "Last Month" },
];

// Every filterable chart defaults to today.
export const defaultChartPeriods = {
  visitType: "today",
  dealerStatus: "today",
  uniqueVisits: "today",
  location: "today",
  pjp: "today",
  avgTimeSpent: "today",
};

export const getDateRangeByPeriod = (period) => {
  const today = moment();
  switch (period) {
    case "yesterday": {
      const y = moment().subtract(1, "day");
      return { start: y.format(FMT), end: y.format(FMT) };
    }
    case "last7":
      return { start: moment().subtract(6, "days").format(FMT), end: today.format(FMT) };
    case "last30":
      return { start: moment().subtract(29, "days").format(FMT), end: today.format(FMT) };
    case "thisMonth":
      return { start: moment().startOf("month").format(FMT), end: today.format(FMT) };
    case "lastMonth":
      return {
        start: moment().subtract(1, "month").startOf("month").format(FMT),
        end: moment().subtract(1, "month").endOf("month").format(FMT),
      };
    case "today":
    default:
      return { start: today.format(FMT), end: today.format(FMT) };
  }
};
